import { actions } from '@luxuryescapes/contract-svc-bundle';

export type BundleSummary = actions['listBundles']['responses']['200']['content']['application/json']['result'][number];

export type BundlePagination = actions['listBundles']['responses']['200']['content']['application/json']['pagination'];

export type Bundle = actions['readBundle']['responses']['200']['content']['application/json']['result'];

export type BundleStatus = Bundle['status'];

export type ListBundlesQuery = actions['listBundles']['parameters']['query'];

export type UpdateBundlePayload = actions['updateBundle']['requestBody']['content']['application/json'];

export const BUNDLE_STATUS_LABELS: Record<BundleStatus, string> = {
  draft: 'Draft',
  approved: 'Approved',
};

export type BundleComponent = Bundle['components'][number];

export type TourBundleComponent = Extract<BundleComponent, { product_type: 'tour' }>;

export type CreateBundleComponentPayload =
  actions['createBundleComponent']['requestBody']['content']['application/json'];

// Tours are checked for single and double availability. Internal only, so not shown in Admin.
export const TOUR_OCCUPANCIES: ReadonlyArray<number> = [1, 2];
